module.exports = __webpack_public_path__ + "img/cats-group.584e33b7.png";